import { Box, Flex } from '@rebass/grid';
import { styled } from 'styles';
import { Button } from 'styles/button';

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 600;
`;

export const Items = styled(Flex)`
  margin: 0 -10px;
`;

export const Item = styled(Box)`
  display: flex;
  color: #fff;
  padding: 0 10px;

  h3 {
    font-size: 1.6rem;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    height: 20px;
    margin-bottom: 10px;
  }

  p {
    font-size: 1.4rem;
    opacity: 0.5;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  a {
    padding: 10px 0;
    color: inherit;
    text-decoration: none;
    flex: 1;
    opacity: 0.9;
    display: block;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);

    &:hover {
      opacity: 1;
    }
  }
`;

export const Meta = styled.span`
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.5);
  display: block;
  margin-top: 5px;

  strong {
    font-weight: inherit;
    color: #fff;
  }
`;

export const LoadMoreButton = styled(Button)`
  margin: 15px auto;
`;
